import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedHeaderComponent } from "./med-header.component";

@NgModule({
  declarations: [
    MedHeaderComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedHeaderComponent,
  ],
})
export class MedHeaderModule { }
